import React from 'react';

import { DataDisputeReportInfoFragment } from 'src/api';
import { TableColumn } from 'src/components/table';
import { useReportItemsFilter } from 'src/hooks/reports';
import { useCurrentUser } from 'src/hooks/user';

import { getDataDisputeReportTableColumnsPEOStaff } from '../utils';

import { DataDisputeReportInnerTable } from './DataDisputeReportInnerTable';

export const DataDisputeReportTablePEOAdmin: React.FC = () => {
  const { timezone } = useCurrentUser();
  const { filter } = useReportItemsFilter();

  const columns = React.useMemo<Array<TableColumn<DataDisputeReportInfoFragment>>>(
    () => getDataDisputeReportTableColumnsPEOStaff(timezone),
    [timezone],
  );

  return <DataDisputeReportInnerTable columns={columns} filter={filter} />;
};
